import {
  Modal,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  Button,
} from '@grupoboticario/flora-react';
import {
  MinusCircleIcon,
  PlusCircleIcon,
} from '@grupoboticario/flora-react-icons';

import { useEffect, useMemo, useState } from 'react';
import Text from 'styles/typography';
import {
  getStepsByIdAction,
  getClaimByIdAction,
  cleanTimelineAction,
} from 'store/modules/claims/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store/store.inteface';
import { useWindowSize } from 'hooks';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { ROLES } from 'config/roles';
import {
  ModalBodyStyled,
  ClaimInfo,
  ClaimDetails,
  Timeline,
  TimelineHistory,
} from './styles';
import { useClaimsStatus } from './useClaimStatus';
import { useClaimsStatusHistory } from './useClaimStatusHistory';
import { ClaimStatus } from './ClaimStatus';
import { ClaimStatusHistory } from './ClaimStatusHistory';
import 'swiper/css';

interface ModalTimelineProps {
  showActions?: boolean;
}

export function ModalTimeline({
  showActions = true,
}: Readonly<ModalTimelineProps>) {
  const dispatch = useDispatch();
  const { windowSize } = useWindowSize();
  useMemo(
    () => windowSize.width && windowSize.width > 0 && windowSize.width <= 768,
    [windowSize.width],
  );
  const mountedClaimsStatus = useClaimsStatus();

  const mountedClaimsHistory = useClaimsStatusHistory();

  const [visible, setVisible] = useState(false);

  const { claimById: claim, timelineClaimId: claimId } = useSelector(
    (state: ApplicationState) => state.claims,
  );
  const { stores } = useSelector(
    (state: ApplicationState) => state.storesContext,
  );

  const { rolesList } = useSelector((state: ApplicationState) => state.roles);

  const onOpenChange = () => {
    dispatch(cleanTimelineAction());
    setVisible(false);
  };

  useEffect(() => {
    if (
      (claimId && stores.length > 0) ||
      (claimId && rolesList[0] === ROLES.MANAGEMENT)
    ) {
      dispatch(getClaimByIdAction(claimId));
      dispatch(getStepsByIdAction(claimId));
    }
  }, [claimId, stores, dispatch, rolesList]);

  useMemo(
    () => ({
      '0': {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      '400': {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      '500': {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
      '700': {
        slidesPerView: 5,
        slidesPerGroup: 5,
      },
    }),
    [],
  );

  return (
    <Modal open={!!claimId} onOpenChange={onOpenChange}>
      <ModalContent size="large">
        <ModalCloseButton />
        <ModalHeader />
        <ModalBodyStyled>
          <header>
            <Text>Acompanhe o andamento do seu sinistro:</Text>
            <ClaimInfo>
              <ClaimDetails>
                <Text className="claim-text claim-label">Sinistro</Text>
                <LoadingSkeleton loading={!claim.number}>
                  <Text className="claim-text">Número: {claim.number}</Text>
                </LoadingSkeleton>
              </ClaimDetails>
              <ClaimDetails>
                <Text className="claim-text claim-label">Loja </Text>
                <LoadingSkeleton loading={!claim.franchise}>
                  <Text className="claim-text">
                    {`${claim?.franchise?.code} - ${claim?.franchise?.name}`}
                  </Text>
                </LoadingSkeleton>
              </ClaimDetails>
              <ClaimDetails>
                <Text className="claim-text claim-label">Tipo de Sinistro</Text>
                <LoadingSkeleton loading={!claim.subCoverage}>
                  <Text className="claim-text">{claim?.subCoverage?.name}</Text>
                </LoadingSkeleton>
              </ClaimDetails>
            </ClaimInfo>
          </header>
          <main>
            <Timeline>
              {mountedClaimsStatus?.map((step, index) => {
                const key = `timeline-${index}`;
                return (
                  <div className="timeline-status" key={key}>
                    <ClaimStatus
                      claimId={claimId}
                      date={step.date}
                      status={step.status}
                      icon={step.icon}
                      description={step.description}
                      color={step.color}
                      onButtonClick={
                        showActions ? step.onButtonClick : undefined
                      }
                      buttonTitle={step.buttonTitle}
                    />
                  </div>
                );
              })}
            </Timeline>
          </main>
          <Button
            style={{ marginTop: '20px' }}
            size="small"
            onClick={() => setVisible(!visible)}
            has="iconRight"
            icon={
              visible ? (
                <MinusCircleIcon size={18} />
              ) : (
                <PlusCircleIcon size={18} />
              )
            }
          >
            Visualizar histórico
          </Button>
          {visible && (
            <main>
              <TimelineHistory>
                {mountedClaimsHistory?.map(value => (
                  <>
                    <ClaimStatusHistory
                      date={value.date}
                      status={value.status}
                      description={value.description}
                      icon={value.icon}
                      color={value.color}
                    />
                    <div className="claim-dot">&gt;</div>
                  </>
                ))}
              </TimelineHistory>
            </main>
          )}
        </ModalBodyStyled>
      </ModalContent>
    </Modal>
  );
}
